import { combineReducers } from "@reduxjs/toolkit";
import authReducer, { logOut } from "../slices/authSlice";
import networkReducer from "../../components/context/Network/networkReducer";
import myDataReducer from "../slices/myDataSlice";
import modalReducer from "./../slices/modalSlice";
import uiReducer from "./../slices/uiSlice";
import newsletterReducer from "./../slices/newsletterSlice";
import deleteChannelReducer from "./../slices/deleteChannelSlice";
import deleteTopicReducer from "./../slices/deleteTopicSlice";
import themeReducer from "./../slices/themeSlice";
import createChannelReducer from "./../slices/createChannelSlice";
import createTopicReducer from "./../slices/createTopicSlice";
import topicReducer from "./../slices/topicSlice";
import channelItemsReducer from "./../slices/channelItemsSlice";
import channelReducer from "./../slices/channelSlice";
import chatReducer from "./../slices/chatSlice";
import reorderTopicReducer from "./../slices/reorderTopicSlice";
import eventReducer from "./../slices/eventSlice";
import dmReducer from "./../slices/dmSlice";
import adminReducer from "./../slices/adminSlice";
import businessReducer from "./../slices/businessSlice";
import pollReducer from "./../slices/pollSlice";

export const appReducer = {
  auth: authReducer,
  network: networkReducer,
  myData: myDataReducer,
  modals: modalReducer,
  ui: uiReducer,
  newsletter: newsletterReducer,
  channelDeletion: deleteChannelReducer,
  topicDeletion: deleteTopicReducer,
  theme: themeReducer,
  createChannel: createChannelReducer,
  createTopic: createTopicReducer,
  channelItems: channelItemsReducer,
  topic: topicReducer,
  channel: channelReducer,
  chat: chatReducer,
  reorderTopic: reorderTopicReducer,
  event: eventReducer,
  dmChat: dmReducer,
  admin: adminReducer,
  business: businessReducer,
  poll: pollReducer,
};

const combinedReducer = combineReducers(appReducer);

const rootReducer = (state, action) => {
  if (action.type === logOut.type) {
    state = undefined;
  }
  return combinedReducer(state, action);
};

export default rootReducer;
